import { Check, ChevronsUpDown, Globe } from "lucide-react"
import { Button } from "@/components/ui/Button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu"
import MarketFlag from "@/components/layout/MarketFlag"
import type { Market } from "@/lib/useMarket"

interface Props {
  market: Market | null
  markets: Market[]
  onChange: (market: Market) => void
}

// The panel's own market. Picking one here changes only the panel, never the
// remembered market or the page behind it.
export default function MarketSwitcher({ market, markets, onChange }: Props) {
  if (markets.length === 0) return null
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-2 px-3 text-xs">
          {market ? <MarketFlag market={market} /> : <Globe size={14} />}
          {market ? market.name : "Pick a market"}
          <ChevronsUpDown size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[200px]">
        {markets.map((m) => (
          <DropdownMenuItem key={m.id} onSelect={() => onChange(m)} className="justify-between gap-2">
            <span className="flex items-center gap-2">
              <MarketFlag market={m} />
              {m.name}
            </span>
            {market?.id === m.id && <Check size={14} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
